/* eslint-disable jsx-a11y/no-static-element-interactions */
import Image from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type Props = {
  className?: string;
  imgLink: string;
  selected?: boolean;
  label: string;
  onClick: () => void;
};

const MapOption: React.FC<Props> = ({
  className = '',
  imgLink,
  selected = false,
  label,
  onClick,
}: Props) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={twMerge(
        'flex cursor-pointer flex-col items-center',
        className
      )}
      onClick={onClick}
    >
      <div>
        <Image
          alt=""
          className={twMerge(
            selected && 'border-[2px] border-blue-utility p-[2px]'
          )}
          height={64}
          src={imgLink}
          width={64}
        />
      </div>

      <Typography
        className={twMerge(
          'text-wrap max-w-[64px] pt-2 text-center',
          selected ? 'text-white' : 'text-gray-40'
        )}
        variant={selected ? 'button2' : 'body2'}
      >
        {label}
      </Typography>
    </div>
  );
};

export default MapOption;
